interface ApiError {
    message?: string;
    message_description?: string;
    [key: string]: any;
}

interface ThunkError {
    error: string;
    status?: number;
    data?: ApiError | null;
}

export const handleThunkError = (err: unknown, rejectWithValue: Function) => {
    if (isAxiosError(err)) {
        const errorData: ApiError = err.response?.data || {};
        return rejectWithValue({
            error:
                errorData.message_description ||
                errorData.message ||
                'Request failed',
            status: err.response?.status,
            data: errorData,
        } as ThunkError);
    }

    return rejectWithValue({
        error: err instanceof Error ? err.message : 'Unknown error occurred',
    } as ThunkError);
};

function isAxiosError(error: unknown): error is {
    isAxiosError: boolean;
    response?: {
        status?: number;
        data: ApiError
    }
} {
    return typeof error === 'object' && error !== null && 'isAxiosError' in error;
}
